import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-swiper-next",
  "use": "icon-swiper-next-usage",
  "viewBox": "0 0 8 13",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 13\" id=\"icon-swiper-next\"><path d=\"M0 11.692V1.308C0 .433 1.045-.02 1.684.578L7.222 5.77a1 1 0 0 1 0 1.46l-5.538 5.19c-.639.6-1.684.146-1.684-.73Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol